import Button from "./Button";

export function LoginButton({ isLoading }) {
  return (
    <Button
      type="primary"
      label="Login"
      size="small"
      disabled={isLoading}
      loading={isLoading}
      stretch={true}
      center={true}
    />
  );
}
